import {createStackNavigator} from '@react-navigation/stack';

export const Stack = createStackNavigator();
